import * as React from "react";
import {
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { Company } from "../../types/company";
import { useNavigate } from "react-router-dom";
import Edit from "@mui/icons-material/Edit";
import { CardBase, Button, GlassTable } from "../../components/global";

const CompanyProfilePanel = ({ data }: { data?: Company; }) => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <CardBase
          title="About"
          useGlassCard={false}
          sx={{ mb: 2 }}
        >
          <GlassTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259", width: "30%" }}>
                    Client Name
                  </TableCell>
                  <TableCell>{data?.name || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Phone</TableCell>
                  <TableCell>{data?.phone_number || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Fax</TableCell>
                  <TableCell>{data?.fax || "n/a"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </GlassTable>
        </CardBase>
        <CardBase
          title="Settings"
          useGlassCard={false}
          sx={{ mb: 2 }}
        >
          <GlassTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259", width: "30%" }}>
                    Industry
                  </TableCell>
                  <TableCell>{data?.business_vertical?.name || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>
                    Uplift Percentage
                  </TableCell>
                  <TableCell>
                    {!!data?.percentage_uplift
                      ? `${data?.percentage_uplift}%`
                      : "(not set)"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>
                    Color Scheme
                  </TableCell>
                  <TableCell>{data?.color_schema || "n/a"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </GlassTable>
        </CardBase>
        <CardBase
          title="Contact Person"
          useGlassCard={false}
          sx={{ mb: 2 }}
        >
          <GlassTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259", width: "30%" }}>
                    Name
                  </TableCell>
                  <TableCell>{data?.primary_contact_name || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Title</TableCell>
                  <TableCell>{data?.primary_contact_title || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>
                    Phone Number
                  </TableCell>
                  <TableCell>{data?.primary_contact_phone_number || "n/a"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Email</TableCell>
                  <TableCell>{data?.primary_contact_email || "n/a"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </GlassTable>
        </CardBase>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={2}>
          <Button
            fullWidth
            variant="contained"
            disabled={!data}
            onClick={() => navigate(`/clients/${data?.id}/edit`)}
            startIcon={<Edit />}
            sx={{
              mb: 2,
              backgroundColor: "#F4A259",
              color: "#ffffff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#E8944A",
              },
              "&:disabled": {
                backgroundColor: "rgba(244, 162, 89, 0.5)",
                color: "rgba(255, 255, 255, 0.7)",
              },
            }}
          >
            Edit Client
          </Button>
          <CardBase
            title="Contact"
            useGlassCard={false}
            sx={{ mb: 2 }}
          >
            <GlassTable>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259", width: "40%" }}>
                      Address 1
                    </TableCell>
                    <TableCell>{data?.headquarters_address_1 || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>
                      Address 2
                    </TableCell>
                    <TableCell>{data?.headquarters_address_2 || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>
                      City / Zip
                    </TableCell>
                    <TableCell>
                      {data?.city && data?.zip
                        ? `${data.city} / ${data.zip}`
                        : data?.city || data?.zip
                          ? `${data.city || ""} ${data.zip || ""}`.trim()
                          : "n/a"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>State</TableCell>
                    <TableCell>{data?.state || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Country</TableCell>
                    <TableCell>{data?.country_id || "n/a"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </GlassTable>
          </CardBase>
          <CardBase
            title="Social Media"
            useGlassCard={false}
          >
            <GlassTable>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259", width: "40%" }}>
                      LinkedIn
                    </TableCell>
                    <TableCell>{data?.linked_in || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Facebook</TableCell>
                    <TableCell>{data?.facebook || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Instagram</TableCell>
                    <TableCell>{data?.instagram || "n/a"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "#F4A259" }}>Website</TableCell>
                    <TableCell>{data?.website || "n/a"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </GlassTable>
          </CardBase>
        </Stack>
      </Grid>
    </Grid>
  );
};
export default CompanyProfilePanel;
